// src/features/settings/components/ProfileCard.tsx
import { Card } from '../../../app/components/foundation';

interface ProfileCardProps {
  name: string;
}

export function ProfileCard({ name }: ProfileCardProps) {
  const initial = name.trim().charAt(0).toUpperCase();

  return (
    <Card elevated noPadding className="representative-profile-hero">
      <div className="representative-profile-hero__identity">
        <span className="representative-profile-hero__avatar" aria-hidden="true">
          {initial}
        </span>

        <div className="representative-profile-hero__content">
          <p className="representative-profile-hero__name">
            {name}
          </p>
        </div>
      </div>
    </Card>
  );
}
